import createCachedSelector from 're-reselect'
import { createBasicSelector } from 'util/redux'
import { emptyObj } from 'util/objects'
import { groupByToMap } from 'util/arrays'

export const selectIntegrationData = state =>
  state.integrations.thirdPartyData.shopify

export const selectOrders = state =>
  state.integrations.thirdPartyData.shopify.orders

export const selectOrdersLoading = createBasicSelector(
  selectOrders,
  orders => orders.isLoading
)

export const selectOrdersByCustomerId = createBasicSelector(
  selectOrders,
  orders => orders.byCustomerId || emptyObj
)

export const selectEvents = state =>
  state.integrations.thirdPartyData.shopify.events

export const selectEventsLoading = createBasicSelector(
  selectEvents,
  events => events.isLoading
)

export const selectIsLoading = createBasicSelector(
  selectOrdersLoading,
  selectEventsLoading,
  (ordersLoading, eventsLoading) => ordersLoading || eventsLoading
)

export const selectEventsByCustomerId = createBasicSelector(
  selectEvents,
  events => events.byCustomerId || emptyObj
)

export const selectEventsForCustomerId = createCachedSelector(
  selectEventsByCustomerId,
  (state, { customerId }) => customerId,
  (byCustomerId, customerId) => {
    const forCustomerId = byCustomerId[customerId]
    return forCustomerId
  }
)((state, { customerId }) => customerId)

export const selectEventsForCustomerIdGroupedByDay = createCachedSelector(
  selectEventsByCustomerId,
  (state, { customerId }) => customerId,
  (byCustomerId, customerId) => {
    const forCustomerId = byCustomerId[customerId] || []
    return groupByToMap(forCustomerId, ({ date }) => date)
  }
)((state, { customerId }) => customerId)

export const selectOrdersForCustomerId = createCachedSelector(
  selectOrdersByCustomerId,
  (state, { customerId }) => customerId,
  (byCustomerId, customerId) => {
    const forCustomerId = byCustomerId[customerId] || []
    return forCustomerId
  }
)((state, { customerId }) => customerId)
